export interface UseGeolocationReturn {
  geolocationCoordinates: Ref<Coordinates | null>;
  getGeolocation: () => void;
  error: Ref<GeolocationPositionError | null>;
}

export function useGeolocation(): UseGeolocationReturn {
  const geolocationCoordinates = ref<Coordinates | null>(null);
  const error = ref<GeolocationPositionError | null>(null);

  function getGeolocation(): void {
    navigator.geolocation.getCurrentPosition(
      (position: GeolocationPosition) => {
        geolocationCoordinates.value = [
          position.coords.longitude,
          position.coords.latitude,
        ];
      },
      err => {
        error.value = err;
      },
      { maximumAge: 60000, timeout: 10000, enableHighAccuracy: true }
    );
  }

  return {
    geolocationCoordinates,
    getGeolocation,
    error,
  };
}
